const fulldateFormatter = new Intl.DateTimeFormat('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
});

const fullTimeFormatter = new Intl.DateTimeFormat('en-US', {
    hour: '2-digit',
    minute: '2-digit',
});

export const formatDate = (date: Date) => {
    return fulldateFormatter.format(date);
};

export const formatTime = (date: Date) => {
    return fullTimeFormatter.format(date);
};

export const formatDateTime = (date: Date) => {
    return `${formatDate(date)} at ${formatTime(date)}`;
};
